import { Box, Button, FormControl, InputLabel, Typography } from '@mui/material'
import { useFormContext, useController } from 'react-hook-form'
import { useState, useEffect } from 'react'
import { ChooseLocationsModal } from '../../pages/Contests/LocationSweepstakes/ChooseLocationsModal'
import { type LicensedEstablishment } from 'types/api'

interface LocationSelectProps {
  name: string
  showLabel?: boolean
  defaultValue?: number[]
  defaultSelected?: LicensedEstablishment[]
  [key: string]: unknown
}

export const LocationSelect = ({
  name,
  showLabel,
  defaultValue,
  defaultSelected,
  ...otherProps
}: LocationSelectProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const { watch, control, setValue } = useFormContext()
  const fieldName = name
  const licensedEstablishmentIds = watch(fieldName) as LicensedEstablishment[]
  // registers a focusable ref so RHF can scroll/focus this field on validation errors
  const { field } = useController({ name: fieldName, control })

  // if there are default licensedEstablishmentIds, set them on mount
  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      setValue(fieldName, defaultValue)
    } else {
      setValue(fieldName, [])
    }
  }, [])

  const saveLocations = (
    locations: Array<{ licensedEstablishmentId: number }>
  ) => {
    const ids = locations.map((loc) => loc.licensedEstablishmentId)
    setValue(fieldName, ids)
  }

  return (
    <FormControl {...otherProps}>
      {showLabel ? (
        <InputLabel
          id={`${fieldName}-label`}
          htmlFor={fieldName}
          required={true}
        >
          Licensed Establishments
        </InputLabel>
      ) : null}
      <Box display="flex" alignItems="flex-end">
        <Button
          ref={field.ref}
          variant="contained"
          onClick={() => setModalOpen(true)}
        >
          Choose Locations
        </Button>
        <Typography style={{ marginLeft: '10px' }}>
          {`${licensedEstablishmentIds?.length ?? 0} location(s) selected`}
        </Typography>
      </Box>
      <ChooseLocationsModal
        defaultSelected={defaultSelected ?? []}
        isModalOpen={modalOpen}
        toggleIsOpen={() => setModalOpen(false)}
        saveLocations={saveLocations}
      />
    </FormControl>
  )
}
